import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { filtersToQuery } from '../utils/filtersToQuery';

import PROPERTIES from '../api/ressources/properties';

export const getProperties = createAsyncThunk(
  '/propertiesIndex',
  async (filters) => {
    const response = await PROPERTIES.getProperties({ filters: filtersToQuery(filters) })
    return response.data
  }
);

export const getCoordinates = createAsyncThunk(
  '/coordinatesIndex',
  async (filters) => {
    const response = await PROPERTIES.getCoordinates(filtersToQuery(filters))
    return response.data
  }
);

export const getTotalPrevision = createAsyncThunk(
  '/previsionsTotal',
  async (filters) => {
    const response = await PROPERTIES.getProperties({ filters: filtersToQuery(filters), perPage: 0 })
    return response.data
  }
);

export const getProperty = createAsyncThunk(
  '/propertyShow',
  async (id) => {
    const response = await PROPERTIES.getProperty(id)
    return response.data
  }
)

export const fetchNextProperties = createAsyncThunk(
  '/propertiesIndexNextPage',
  async ({filters, page}) => {
    const response = await PROPERTIES.getProperties({ filters: filtersToQuery(filters), page: page })
    return response.data
  }
);

const initialState = {
  collection: [],
  collectionTotal: 0,
  coordinates: [],
  totalPrevision: 0,
  requestPropertiesState: '',
  page: 1,
};

export const propertiesSlice = createSlice({
  name: 'properties',
  initialState,
  reducers: {
    resetProperties(state) {
      state = initialState;
    },
    setPage(state, { payload }) {
      state.page = payload;
    },
    removeProperty(state) {
      state.property = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getProperties.pending, (state) => {
      state.requestPropertiesState = 'pending'
    })
    builder.addCase(getProperties.fulfilled, (state, { payload }) => {
      const { results, page, total } = payload;
      state.collection = results;
      state.collectionTotal = total;
      state.page = page;
      state.requestPropertiesState = 'done';
    })
    builder.addCase(getCoordinates.fulfilled, (state, { payload }) => {
      state.coordinates = payload;
    })
    builder.addCase(getTotalPrevision.pending, (state, { payload }) => {
      state.requestPrevisionsState = 'pending'
    })
    builder.addCase(getTotalPrevision.fulfilled, (state, { payload }) => {
      state.totalPrevision = payload.total
      state.requestPrevisionsState = 'done';
    })
    builder.addCase(fetchNextProperties.pending, (state) => {
      state.requestFetchState = 'pending'
    })
    builder.addCase(fetchNextProperties.fulfilled, (state, { payload }) => {
      let newCollection = state.collection.concat(payload.results);
      let ids = newCollection.map((property) => property.id);
      // filter newCollection to avoid duplicates
      let filteredCollection = newCollection.filter(({ id }, index) => !ids.includes(id, index + 1));
      state.collection = filteredCollection;
      state.requestFetchState = 'done';
    })
    builder.addCase(getProperty.pending, (state) => {
      state.requestPropertyState = 'pending'
    })
    builder.addCase(getProperty.fulfilled, (state, { payload }) => {
      state.property = payload;
      state.requestPropertyState = 'done';
    })
  },
})

export const { resetProperties, setPage, removeProperty } = propertiesSlice.actions;

export default propertiesSlice.reducer;
